const faq = (state: any = {}, action: any) => {
  switch(action.type) {
    case 'FETCH_FAQ':
      return { ...state, categories: action.payload };
    default:
      return state;
  }
}

export default faq;



// WEBPACK FOOTER //
// ./src/reducers/faq.js